import React from 'react';
import Layout from '../../components/Layout/Layout';
import Home from '../../pages/Home/Home';
import styles from './HomePage.module.css';

const HomePage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.homePageStack}>
        <Home size="Desktop 1440" />
      </div>
    </Layout>
  );
};

export default HomePage;